import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProjectNew } from './hooks/useProjectNew';
import { ProjectBasicInfo } from './components/ProjectBasicInfo';
import { ProjectTimelineInfo } from './components/ProjectTimelineInfo';
import { ProjectFinancialInfo } from './components/ProjectFinancialInfo';
import { ProjectAttachments } from './components/ProjectAttachments';
import { ProjectSidebarInfo } from './components/ProjectSidebarInfo';
import { ProjectTeamInfo } from './components/ProjectTeamInfo';
import { PageHeaderNew } from '@/components/ui';

export function ProjectNewPage() {
  const navigate = useNavigate();
  const { form, updateForm, isSaving, createProject, managers, thumbnailFile, setThumbnailFile, attachmentFiles, setAttachmentFiles } = useProjectNew();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const id = await createProject(form);
      navigate(`/projects/${id}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col h-full bg-slate-50/50">
      {/* Main Content Form */}
      <form id="project-form" onSubmit={handleSubmit} className="flex-1 p-6 overflow-y-auto">
        <div className="w-full">
          {/* Header Block (Full width) */}
          <PageHeaderNew 
            title="Thêm dự án"
            subtitle="Nhập thông tin chi tiết để khởi tạo dự án mới trên hệ thống."
            backUrl="/projects"
          />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
            {/* Left Column: Main form blocks (8/12) */}
            <div className="lg:col-span-8 space-y-6">
              {/* Block 2: Basic Info */}
              <ProjectBasicInfo form={form} updateForm={updateForm} managers={managers} />
              <ProjectTimelineInfo form={form} updateForm={updateForm} />
              <ProjectFinancialInfo form={form} updateForm={updateForm} />
              <ProjectTeamInfo form={form} updateForm={updateForm} />
            </div>

            {/* Right Column: Sidebar blocks (4/12) */}
            <div className="lg:col-span-4 sticky top-0">
              <ProjectSidebarInfo 
                form={form} 
                updateForm={updateForm} 
                isSaving={isSaving}
                onCancel={() => navigate('/projects')}
                thumbnailFile={thumbnailFile}
                setThumbnailFile={setThumbnailFile}
                attachmentFiles={attachmentFiles}
                setAttachmentFiles={setAttachmentFiles}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ProjectNewPage;
